<div class="container p-4">
    <div class="card border-0 shadow-sm mb-3 py-1 px-4">
        <dx-toolbar class="theme-dependent">
            <dxi-item location="before">
                <div class="header-text">Bin Details</div>
            </dxi-item>
            <dxi-item location="after" locateInMenu="never">
                <dx-button
                    text="Back"
                    stylingMode="outlined"
                    type="normal"
                    (onClick)="cancel()"
                >
                </dx-button>
                <dx-button
                    class="ms-2"
                    text="Save"
                    stylingMode="contained"
                    type="default"
                    (onClick)="save()"
                >
                </dx-button>
            </dxi-item>
        </dx-toolbar>
    </div>

    <dx-load-panel
        container=".view-wrapper-scroll"
        [visible]="isLoading"
        [showPane]="false"
        [position]="{ of: 'bin-details' }"
    >
    </dx-load-panel>

    <dx-scroll-view class="view-wrapper-scroll">
        @if (!isLoading) {
            <div class="form-container">
                <div class="card border-0 shadow-sm pt-0">
                    <div class="card-header fs-5 fw-medium d-flex justify-content-between align-items-center bg-transparent py-3">
                        <div>General Information</div>
                        <div class="text-muted">ID: {{ bin.number }}</div>
                    </div>
                    <div class="card-body">
                        <div class="row g-3">
                            <div class="col-md-4">
                                <div class="mb-4">
                                    <label class="form-label">Storage Type</label>
                                    <dx-select-box
                                        [(value)]="bin.storageTypeCode"
                                        [dataSource]="storageTypeCodeOptions"
                                        [showClearButton]="true"
                                        stylingMode="filled"
                                        [searchEnabled]="true"
                                    ></dx-select-box>
                                </div>
                                <div class="mb-4">
                                    <label class="form-label">Max Pallets</label>
                                    <dx-number-box
                                        [(value)]="bin.maxPallets"
                                        [min]="0"
                                        stylingMode="filled"
                                    ></dx-number-box>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-4">
                                    <label class="form-label">Storage Bin Type</label>
                                    <dx-select-box
                                        [(value)]="bin.storageBinType"
                                        [dataSource]="storageBinTypeOptions"
                                        [showClearButton]="true"
                                        stylingMode="filled"
                                        [searchEnabled]="true"
                                    ></dx-select-box>
                                </div>
                                <div class="mb-4">
                                    <label class="form-label">Aisle</label>
                                    <dx-text-box
                                        [(value)]="bin.aisle"
                                        stylingMode="filled"
                                    ></dx-text-box>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-4">
                                    <label class="form-label">Type</label>
                                    <dx-select-box
                                        [(value)]="bin.storageType"
                                        [dataSource]="storageTypeOptions"
                                        [showClearButton]="true"
                                        displayExpr="text"
                                        valueExpr="value"
                                        stylingMode="filled"
                                    ></dx-select-box>
                                </div>
                                <div class="mb-4">
                                    <label class="form-label">Zone</label>
                                    <dx-select-box
                                        [(value)]="bin.zone"
                                        [dataSource]="zoneOptions"
                                        [showClearButton]="true"
                                        stylingMode="filled"
                                        [searchEnabled]="true"
                                    ></dx-select-box>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
    </dx-scroll-view>
</div>

